<div *ngIf="!selectedAddress" >
  <label id="listbox-label" class="block text-sm font-medium leading-6 text-gray-900"></label>
  <div class="relative mt-2">
    <div class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-3 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-accent-lighter sm:text-sm sm:leading-6" >
      

      <div class="relative my-2 rounded-md shadow-sm">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          
        </div>
        <input [formControl]="searchControl" type="text" class="block border-0 w-full rounded-md py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6" placeholder="Search for address...">
        
        <div (click)="toggleList()" class=" absolute inset-y-0 right-0 flex items-center pr-3">
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </div>

      </div>

    </div>

   

    <div id="list-wrap" *ngIf="listOpen" class="relative z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white pt-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">
      <ul class="pb-6">
        <li (click)="addressPicked(address)" *ngFor="let address of options" class="relative group cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-accent-light hover:text-white" id="listbox-option-0" role="option">
          <div class="flex">
            <div class="w-8 h-8 rounded-full mr-2 opacity-60 text-accent flex flex-col justify-center text-center text-xs group-hover:bg-white group-hover:text-accent group-hover:ring-accent" ></div>
            <span class="truncate font-normal">{{ address.formattedAddress }}</span>
            
          </div>
          <span *ngIf="address.id === (selectedAddress && selectedAddress.id)" class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-hover:text-white">
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
            </svg>
          </span>
        </li>
      </ul>

      
    
      
    </div> 

    <div id="new-address" (click)="createNewAddressClicked()" class=" w-full bg-white border-t border-t-gray-200 py-4 px-3 cursor-pointer">
      <div class="flex justify-end">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 mr-2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
        </svg>

        <span class="truncate font-normal">Create manually</span>
      </div>
    </div>
    
  </div>
</div>

<div class="" *ngIf="selectedAddress">
  <form class="" [formGroup]="addressForm" (ngSubmit)="formSubmitted()">
    <div class="relative mt-2 space-y-4">

      <!-- Line 1 -->
      <div>
        <label for="line1" class="block text-sm font-medium leading-6 text-gray-900">Line 1</label>
        <div class="mt-2">
          <input formControlName="line1" type="text"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
            placeholder="Address line 1">
          <div class="text-red-600 text-sm mt-1" *ngIf="addressForm.get('line1')?.touched && addressForm.get('line1')?.invalid">
            <div *ngIf="addressForm.get('line1')?.errors?.['required']">Line 1 is required.</div>
          </div>
        </div>
      </div>

      <!-- Line 2 -->
      <div>
        <label for="line2" class="block text-sm font-medium leading-6 text-gray-900">Line 2</label>
        <div class="mt-2">
          <input formControlName="line2" type="text"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
            placeholder="Address line 2 (optional)">
        </div>
      </div>

      <!-- Town -->
      <div>
        <label for="town" class="block text-sm font-medium leading-6 text-gray-900">Town</label>
        <div class="mt-2">
          <input formControlName="town" type="text"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
            placeholder="Town">
          
        </div>
      </div>

      <!-- City -->
      <div>
        <label for="city" class="block text-sm font-medium leading-6 text-gray-900">City</label>
        <div class="mt-2">
          <input formControlName="city" type="text"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
            placeholder="City">
          
        </div>
      </div>

      <!-- Postcode -->
      <div>
        <label for="postcode" class="block text-sm font-medium leading-6 text-gray-900">Postcode</label>
        <div class="mt-2">
          <input formControlName="postcode" type="text"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
            placeholder="Postcode">
          
        </div>
      </div>

      <!-- What 3 Words -->
      <div>
        <label for="w3w" class="block text-sm font-medium leading-6 text-gray-900">What 3 Words</label>
        <div class="mt-2">
          <input formControlName="w3w" type="text"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
            placeholder="What 3 words location (optional)">
        </div>
      </div>

      <!-- Notes -->
      <div>
        <label for="notes" class="block text-sm font-medium leading-6 text-gray-900">Notes</label>
        <div class="mt-2">
          <textarea formControlName="notes" rows="4"
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"></textarea>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-between gap-x-6 border-t border-gray-900/10 py-4">
        <button type="button" (click)="cancelClicked()"
          class="rounded-md px-3 py-2 text-xs font-semibold text-gray-400 hover:text-accent-light">Cancel</button>
        <button type="submit" [disabled]="!addressForm.valid"
          class="rounded-md bg-accent px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-accent-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">
          {{ buttonTitle }}
        </button>
      </div>

    </div>
  </form>
</div>